export default "__VITE_ASSET__9a7ac754__"